var map = {
	"./intl-en": [
		6048,
		615,
		421
	],
	"./intl-en.js": [
		6048,
		615,
		421
	],
	"./intl-fr": [
		2613,
		615,
		405
	],
	"./intl-fr.js": [
		2613,
		615,
		405
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2203;
module.exports = webpackAsyncContext;